angular.module('vehicle', ['core', 'vehicle-location', 'ui-leaflet', 'vehicle-issue'])
    .constant('VehicleConst', {
        eventUpdate: 'vehicle.updated',
        tpl: 'app/vehicle/'
    })
    .factory('Vehicle', function ($resource) {
        return $resource('crm/api/vehicle/:id', {id: '@id'}, {
            table: {method: 'GET', url: 'crm/api/vehicle/table', isArray: false},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/vehicle/table-statistics'},
            update: {method: 'PUT'},
            deletePhoto: {method: 'DELETE', url: '/crm/api/vehicle/:id/photo'},
            dashboard: {method: 'GET', url: '/crm/api/vehicle/dashboard', isArray: false},
            configuration: {method: 'GET', url: '/crm/api/vehicle/configuration'},
        })
    })
    .service('VehicleService', function (modals, $rootScope, Vehicle, VehicleConst) {
        let configurationPromise

        this.configuration = () => configurationPromise || (configurationPromise = Vehicle.configuration().$promise)
        this.add = params => {
            let entity = {
                id: null,
                status: 'ACTIVE'
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            modals.open(VehicleConst.tpl + 'edit-modal.html', 'VehicleEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.show = entity => {
            modals.open(VehicleConst.tpl + 'show-modal.html', 'VehicleShowController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => Vehicle.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(VehicleConst.eventUpdate)));
        }
        this.types = () => ['CAR', 'TRUCK', 'SUV', 'BUS', 'TWO_WHEEL', 'TRACTOR', 'OTHER']
        this.drives = () => ['FWD', 'RWD', 'AWD', 'OTHER']
        this.fuels = () => ['PETROL', 'DIESEL', 'LPG', 'CNG', 'ELECTRIC', 'HYBRID', 'OTHER']
        this.transmissions = () => ['MT', 'AT', 'NA']
        this.statuses = () => ['ACTIVE', 'INACTIVE', 'DAMAGED', 'OUT_OF_SERVICE', 'SOLD', 'OTHER']
    })
    .controller('VehicleEditController', function (toastr, $scope, $rootScope, $uibModalInstance, Vehicle, VehicleConst, data, VehicleService, FileUploader, $cookies) {
        this.VehicleService = VehicleService
        this.$onInit = () => {
            this.configuration = {}
            VehicleService.configuration().then(configuration => this.configuration = configuration)
            this.statuses = VehicleService.statuses()
            this.types = VehicleService.types()
            this.transmissions = VehicleService.transmissions()
            this.drives = VehicleService.drives()
            this.fuels = VehicleService.fuels()

            this.item = data
            if (this.item.id != null) {
                Vehicle.get({id: this.item.id}).$promise.then(result => {
                    this.item = result
                    this.syncManufacturingSettings()
                })
            }
            this.syncManufacturingSettings()

            this.uploader = new FileUploader({
                url: '/crm/api/vehicle/' + this.item.id + '/photo',
                autoUpload: true,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                },
                onSuccessItem: (fileItem, file, status, headers) => this.onPhotoChanged(file.uuid),
                onErrorItem: (fileItem, response, status, headers) => toastr.error("Błąd wysyłania pliku. Spróbuj ponownie")
            })
        }
        this.syncManufacturingSettings = () => {
            const interval = this.item && this.item.manufacturingSettings && this.item.manufacturingSettings.minimumOrderIntervalMinutes
            this.minimumOrderIntervalEnabled = angular.isNumber(interval) && interval > 0
        }
        this.toggleMinimumOrderInterval = () => {
            this.item.manufacturingSettings = this.item.manufacturingSettings || {}
            this.item.manufacturingSettings.minimumOrderIntervalMinutes = this.minimumOrderIntervalEnabled ? (this.item.manufacturingSettings.minimumOrderIntervalMinutes || 60) : null
        }
        this.onPhotoChanged = (uuid) => {
            toastr.success("Zapisano")
            this.item.photo = uuid;
            $rootScope.$broadcast(VehicleConst.eventUpdate)
        }
        this.deletePhoto = () => Vehicle.deletePhoto({id: this.item.id}).$promise.then(() => this.onPhotoChanged())
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = Vehicle.update(this.item).$promise
            } else {
                $promise = Vehicle.save(this.item).$promise
            }
            $promise
                .then(result => {
                    $rootScope.$broadcast(VehicleConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
            return $promise
        }
    })

    .controller('VehicleShowController', function (toastr, $scope, $rootScope, $uibModalInstance, Vehicle, VehicleConst, data, VehicleService, Principal) {
        this.VehicleService = VehicleService

        this.markers = []
        this.defaults = {
            scrollWheelZoom: false
        }
        this.controls = {
            fullscreen: {
                position: 'topleft'
            }
        }
        // this.isCurrentUserMaintainerOrLocationManager = () => {
        //     let isMaintainer = this.item.bookingSettings.maintainer?.id === this.currentUser.id;
        //     let isLocationManager = this.item.bookingSettings.location?.manager?.id === this.currentUser.id;
        //     return isMaintainer || isLocationManager
        // }
        this.$onInit = () => {
            Principal.currentUser().then(user => this.currentUser = user)
            this.configuration = {}
            VehicleService.configuration().then(configuration => this.configuration = configuration)
            this.item = data
            this.center = {
                lat: 52,
                lng: 19.5,
                zoom: 6
            }
            Vehicle.get({id: this.item.id}).$promise.then(result => {
                this.item = result
                // var smallIcon = {
                //     iconUrl: 'dummy',
                //     iconRetinaUrl: 'dummy',
                //     iconSize:    [0.00, 0.00],
                //     iconAnchor:  [0, 0],
                //     popupAnchor: [1, -34],
                //     shadowSize:  [0, 0]
                // };
                this.markers.push({
                    lat: result.telematics?.coordinates?.latitude,
                    lng: result.telematics?.coordinates?.longitude,
                    message: result.basics.registrationNumber,
                    // icon: smallIcon,
                    icon: {
                        iconUrl: 'static/vehicle.png',
                        iconSize: [13, 27],
                        iconAnchor: [6.5, 13.5]
                        // type: 'awesomeMarker',
                        // icon: 'arrow-up',
                        // markerColor: 'red'
                    },
                    rotationAngle: result.telematics?.heading
                })
                this.center = {
                    lat: result.telematics?.coordinates?.latitude,
                    lng: result.telematics?.coordinates?.longitude,
                    zoom: 12
                }
            }).catch(() => this.cancel())
        }
        this.cancel = () => $uibModalInstance.dismiss()
        $scope.$on(VehicleConst.eventUpdate, () => this.$onInit())
    })
    .controller('VehicleSelectController', function ($http, $scope, $rootScope, $uibModalInstance, data, Vehicle) {
        this.filters = data

        this.$onInit = () => {
            this.load()
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.select = selected => $uibModalInstance.close(selected)
        this.reset = () => this.filters = {}

        this.load = () => {
            let filters = angular.copy(this.filters)
            Vehicle.table(filters).$promise.then(result => this.page = result)
        }
    })
    .component('vehicleList', {
        bindings: {
            statistics: '<',
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/vehicle/list.html',
        controller: function ($scope, $state, $stateParams, Vehicle, VehicleService, VehicleConst) {
            this.VehicleService = VehicleService
            this.reset = () => this.filters = {}
            $scope.$on(VehicleConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
    .component('vehicleMap', {
        bindings: {
            locations: '<',
            statistics: '<',
            filters: '<',
            page: '<',
        },
        templateUrl: 'app/vehicle/map.html',
        controller: function ($scope, $state, $stateParams, Vehicle, VehicleService, VehicleConst) {
            this.VehicleService = VehicleService
            this.reset = () => this.filters = {}
            this.markers = []
            this.paths = [
                // {
                //     weight: 2,
                //     color: '#ff612f',
                //     latlngs: {
                //         lat: 52,
                //         lng: 19.5,
                //         draggable: true
                //     },
                //     radius: 250,
                //     type: 'circle'
                // }
            ]
            this.layers = []
            this.vehicles = []
            this.geofences = []
            this.defaults = {
                // scrollWheelZoom: false
            }
            this.controls = {
                fullscreen: {
                    position: 'topleft'
                }
            }
            this.$onInit = () => {
                this.center = {
                    lat: 52,
                    lng: 19.5,
                    zoom: 8
                }
                this.locations.list.filter(it => it.coordinates != null).forEach(item => {
                    this.paths.push({
                        layer: 'locations',
                        weight: 2,
                        color: '#ff612f',
                        latlngs: {
                            lat: item.coordinates?.latitude,
                            lng: item.coordinates?.longitude,
                            draggable: true
                        },
                        radius: 250,
                        type: 'circle'
                    })
                })
                this.page.list.filter(it => it.telematics != null).forEach(item => {

                    this.markers.push({
                        layer: 'vehicles',
                        lat: item.telematics?.coordinates?.latitude,
                        lng: item.telematics?.coordinates?.longitude,
                        message: item.basics.registrationNumber,
                        icon: {
                            iconUrl: 'static/vehicle.png',
                            iconSize: [13, 27],
                            iconAnchor: [6.5, 13.5]
                        },
                        rotationAngle: item.telematics?.heading,
                        rotationOrigin: 'center center'
                    })
                })


                this.layers = {
                    baselayers: {
                        openStreetMap: {
                            name: 'OpenStreetMap',
                            type: 'xyz',
                            url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                        }
                    },
                    overlays: {
                        vehicles: {
                            name: "Pojazdy",
                            type: "group",
                            visible: true
                        },
                        locations: {
                            name: "Lokalizacje",
                            type: "group",
                            visible: true
                        }
                    }
                };

                // let mark = L.circle([52, 19.5], {radius: 200});
                // this.markers = {
                //     vehicles: [],
                //     locations: []
                // }
                // this.markers.push ({
                //     lat: 52,
                //     lng: 19.5,
                //     type: 'circle',
                // })

                // this.center = {
                //     lat: result.telematics?.coordinates?.latitude,
                //     lng: result.telematics?.coordinates?.longitude,
                //     zoom: 12
                // }
            }
            $scope.$on(VehicleConst.eventUpdate, () => $state.reload())
        }
    })
    .component('vehiclePhoto', {
        bindings: {
            vehicleId: '<',
            photoUuid: '<'
        },
        template: `
            <div class="text-center" ng-if="$ctrl.photoUuid">
                <img class="img-responsive" ng-src="/crm/api/vehicle/{{$ctrl.vehicleId}}/photo?{{$ctrl.photoUuid}}" alt="vehicle photo"/>
            </div>
            <div class="vehicle-photo-placeholder text-center" ng-if="!$ctrl.photoUuid" style="line-height: 50px; vertical-align: middle">
                <i class="fa fa-camera fa-fw fa-2xl"></i>
            </div>
        `
    })
    .component('vehicleStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
                <span class="label label-default vehicle-status-label {{$ctrl.status}}">{{ 'vehicle.status.' + $ctrl.status | translate }}</span>
            `
    })
    .component('vehicleTypeIco', {
        bindings: {
            type: '<'
        },
        template: `
                <i class="fa vehicle-type {{$ctrl.type}}" ng-class="{ 'fa-car': ['CAR', 'SUV', 'TRACTOR'].includes($ctrl.type), 'fa-truck': $ctrl.type==='TRUCK', 'fa-bus': $ctrl.type==='BUS', 'fa-motorcycle': $ctrl.type==='TWO_WHEEL' }" uib-tooltip="{{ 'vehicle.type.'+$ctrl.type | translate }}"></i>
            `
    })
    .component('vehicleBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/vehicle/_btn-options.html',
        controller: function (VehicleService, FilesLibrary, FilesSimpleUploadService) {
            this.VehicleService = VehicleService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_VEHICLE',
            path: '/vehicle',
            ico: 'fa fa-fw fa-car',
            name: 'vehicle.menu',
            order: 102,
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('vehicleList', {
                parent: 'app',
                url: '/vehicle?{page:int}&{size:int}&{sort:string}&{search:string}&status&type&location&maintainer&filter',
                data: {
                    authorities: ['ROLE_VEHICLE'],
                },
                params: {
                    status: {array: true, squash: false},
                },
                views: {
                    'content@': 'vehicleList'
                },
                resolve: {
                    statistics: (Vehicle, $stateParams) => Vehicle.tableStatistics(angular.copy($stateParams)).$promise,
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Vehicle, $stateParams) => Vehicle.table(angular.copy($stateParams)).$promise
                }
            })
            .state('vehicleMap', {
                parent: 'app',
                url: '/vehicle-map?{page:int}&{size:int}&{sort:string}&{search:string}&status&type&location&maintainer&filter',
                data: {
                    authorities: ['ROLE_VEHICLE'],
                },
                params: {
                    status: {array: true, squash: false},
                },
                views: {
                    'content@': 'vehicleMap'
                },
                resolve: {
                    locations: (VehicleLocation, $stateParams) => {
                        let params = angular.copy($stateParams)
                        params.size = 1000
                        return VehicleLocation.table(params).$promise;
                    },
                    statistics: (Vehicle, $stateParams) => Vehicle.tableStatistics(angular.copy($stateParams)).$promise,
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Vehicle, $stateParams) => {
                        let params = angular.copy($stateParams)
                        params.size = 1000
                        return Vehicle.table(params).$promise
                    }
                }
            })
    })
